import { type FC, type MouseEvent } from 'react';
import { useDispatch } from 'react-redux';
import { updateUriRef } from '../../../actions/filterActions.js';
import { SbSharedRefineMenuInputCheckbox } from '../SbSharedRefineMenuInput/SbSharedRefineMenuInputCheckbox.jsx';

type FilterValue = {
    readonly count: number | null;
    readonly displayName: string | null;
    readonly linkReference: string | null;
    readonly urlLabel: string | null;
    readonly isHidden?: boolean | null;
    readonly linkable?: boolean | null;
};

type Props = {
    appliedFilterValues: FilterValue[];
    filterName: string;
    valuesToShow: FilterValue[];
};

export const SbSharedRefineMenuMultiSelect: FC<Props> = ({
    appliedFilterValues,
    filterName,
    valuesToShow,
}) => {
    const dispatch = useDispatch();

    return (
        <>
            {valuesToShow.map((filterValue, index) => {
                const isChecked = appliedFilterValues.some(
                    appliedValue => appliedValue.urlLabel === filterValue.urlLabel
                );
                return (
                    <SbSharedRefineMenuInputCheckbox
                        key={`${filterValue.urlLabel}-${index}`}
                        value={filterValue.urlLabel || ''}
                        checked={isChecked}
                        linkReference={filterValue.linkReference}
                        linkable={filterValue.linkable}
                        onChange={(_checked: boolean, event: MouseEvent<HTMLElement>) => {
                            dispatch(
                                updateUriRef({
                                    filterName,
                                    filterValue,
                                    isDeselected: isChecked,
                                    event,
                                    uriRef: undefined,
                                    ga: undefined,
                                })
                            );
                        }}
                        text={filterValue.displayName || ''}
                        count={filterValue.count}
                        isHidden={filterValue.isHidden}
                    />
                );
            })}
        </>
    );
};
